import abi from './abi.json'
const address = "0x7FFB3d637014488b63fb9858E279385685AFc1e2"
const busd = {abi,address}
export default busd